import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import React from 'react'

interface IRequireAuth {
    allowedRoles : string[]
}

const RequireAuth : React.FC<IRequireAuth> = ({ allowedRoles }) => {
    const { user } = useAuth();
    const location = useLocation();

    return (
        user?.permissions?.find(role => allowedRoles?.includes(role))
            ? <Outlet />
            : <Navigate to="/unauthorized" state={{ from: location }} replace />
    );
}

export default RequireAuth;